import React, { createContext, FC, PropsWithChildren, useState } from 'react';

import { CarouselContextType } from './types';

export const CarouselContext = createContext<CarouselContextType>({
    activeIndex: 0,
    setActiveIndex: (_value: number) => {},
    hasUserChangedIndex: false,
    setHasUserChangedIndex: (_value: boolean) => {},
    shouldShowControls: false,
    setShouldShowControls: (_value: boolean) => {},
    visibleSlides: 0,
    setVisibleSlides: (_value: number) => {},
});

const CarouselContextProvider: FC<PropsWithChildren> = ({ children }) => {
    const [activeIndex, setActiveIndex] = useState<number>(0);
    const [hasUserChangedIndex, setHasUserChangedIndex] = useState<boolean>(false);
    const [shouldShowControls, setShouldShowControls] = useState<boolean>(false);
    const [visibleSlides, setVisibleSlides] = useState<number>(0);

    return (
        <CarouselContext.Provider
            value={{
                activeIndex,
                setActiveIndex,
                hasUserChangedIndex,
                setHasUserChangedIndex,
                shouldShowControls,
                setShouldShowControls,
                visibleSlides,
                setVisibleSlides,
            }}
        >
            {children}
        </CarouselContext.Provider>
    );
};

export default CarouselContextProvider;
